import React from 'react';

export default function StatNumberWithTooltip({ value }) {
    const formatCount = (value) => {
        if (value >= 1_000_000_000) return (value / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
        if (value >= 1_000_000) return (value / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
        if (value >= 1_000) return (value / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
        return value.toString();
    };

    return (
        <div className="relative inline-flex group">
            {/* Changed from <p> to <span> to avoid nesting issues */}
            <span className="text-3xl font-bold text-white mb-2 block">
                {formatCount(value)}
            </span>

            {/* Tooltip */}
            <div className="pointer-events-none absolute left-1/2 bottom-full mb-3 -translate-x-1/2 opacity-0 scale-95 group-hover:opacity-100 group-hover:scale-100 group-hover:-translate-y-2 transition-all duration-200 z-10">
                <div className="relative">
                    <div className="rounded-lg bg-slate-950 border border-slate-700/50 px-4 py-2 shadow-2xl backdrop-blur-sm">
                        {/* Changed from <p> to <span> */}
                        <span className="text-sm font-semibold text-white whitespace-nowrap">
                            {value.toLocaleString()}
                        </span>
                    </div>
                    {/* Tooltip arrow */}
                    <div className="absolute left-1/2 -bottom-1 -translate-x-1/2">
                        <div className="w-2 h-2 rotate-45 bg-slate-950 border-r border-b border-slate-700/50" />
                    </div>
                </div>
            </div>
        </div>
    );
}